/* Twin Turbo "TT" speed monogram (brand variant B): bold italic with a
   planing base cut. Left T is the primary colour, right T is amber.
   Geometry is baked (skew already applied) so it needs no transform. */

const AMBER = '#F2A413';
const TEAL = '#0F766E';

/* Tight viewBox around the glyph (content spans x 15..85, y 22..82) so the
   mark hugs adjacent text without extra padding. */
const VIEW_BOX = '10 17 80 70';
const ASPECT = 70 / 80;

type LogoTone = 'brand' | 'onDark';

interface LogoMarkProps {
  /** Rendered width in px; height follows the mark's aspect ratio. */
  size?: number;
  /** `brand` = teal primary (light backgrounds), `onDark` = white primary. */
  tone?: LogoTone;
  title?: string;
}

export function LogoMark({ size = 24, tone = 'brand', title = 'Twin Turbo' }: LogoMarkProps) {
  const primary = tone === 'onDark' ? '#FFFFFF' : TEAL;
  return (
    <svg
      width={size}
      height={Math.round(size * ASPECT)}
      viewBox={VIEW_BOX}
      role="img"
      aria-label={title}
    >
      <path fill={primary} d="M18.92 22 L52.92 22 L49.69 36 L15.69 36 Z" />
      <path fill={primary} d="M28.92 22 L42.92 22 L30.68 75 L15.07 82 Z" />
      <path fill={AMBER} d="M50.92 22 L84.92 22 L81.69 36 L47.69 36 Z" />
      <path fill={AMBER} d="M60.92 22 L74.92 22 L62.68 75 L47.07 82 Z" />
    </svg>
  );
}
